import classNames from 'classnames'
import { useRef } from 'react'

import useDeviceInfo, { DEVICE_TYPES } from '@src/quince-site-common/src/hooks/useDeviceInfo'

import { withErrorBoundary } from '../errorBoundary'
import { PageLoader } from '../pageLoader'
import { Skeleton } from '../skeleton'

import { getExpressCheckoutSrc } from './express-checkout.helpers'
import styles from './express-checkout.module.scss'

interface ExpressCheckoutProps {
  showBothButtons: boolean
  showPaymentLoader?: boolean
  externalRef: React.MutableRefObject<HTMLIFrameElement | null>
  className?: string
  containerClass?: string
  showLoader?: boolean
}

function ExpressCheckout({
  showBothButtons,
  showPaymentLoader = false,
  externalRef,
  className,
  containerClass,
  showLoader = false,
}: ExpressCheckoutProps) {
  const deviceInfo = useDeviceInfo()
  const isMobile = deviceInfo.deviceType === DEVICE_TYPES.MOBILE
  const { src: iframeSrc } = getExpressCheckoutSrc(showBothButtons, isMobile)
  const ref = useRef<HTMLIFrameElement | null>(null)

  if (!iframeSrc) return null

  return (
    <div className={classNames(styles.expressCheckoutIframeContainer, containerClass)}>
      {showLoader && (
        <div className={styles.expressCheckoutLoaderContainer}>
          <Skeleton fullWidth height={isMobile ? 58 : 50} className={styles.expressCheckoutLoader} />
          {showBothButtons ? <Skeleton fullWidth height={50} className={styles.expressCheckoutLoader} /> : null}
        </div>
      )}
      <PageLoader
        showLoader={showPaymentLoader}
        title="Your payment in currently being processed"
        description="Do not refresh or close your browser."
      />
      <iframe
        title="express-checkout-iframe"
        ref={el => {
          ref.current = el
          externalRef.current = el
        }}
        src={iframeSrc}
        className={classNames(styles.expressCheckoutIframe, className)}
        data-testid="express-checkout-iframe"
      />
    </div>
  )
}

export default withErrorBoundary(ExpressCheckout)
